import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { requestStatuses } from 'shared/../constants/store';
// fetch
import { getStates } from 'src/fetch/general';
// store
import { setStates } from 'src/slices/states';

const useStoreLoading = () => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(requestStatuses.INIT);
  const [error, setError] = useState(null);

  useEffect(() => {
    setStatus(requestStatuses.PENDING);
    getStates()
      .then((states) => {
        dispatch(setStates({ states }));
        setStatus(requestStatuses.SUCCESS);
      })
      .catch((err) => {
        console.log('Organization form initial load error', err);
        setError(err);
        setStatus(requestStatuses.FAILED);
      });
  }, []);

  return { status, error };
};

export default useStoreLoading;
